/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76166Req {
  
    bizNo: string;
  
};



export interface API76166Res {
  /** gant-gant图,progress-进度图  */
  viewType?: string;
  viewData?: any[];
};


// 接口函数 76166 任务图展示

export interface IUseGetAPI76166Return {
  /** 任务图展示: 接口请求状态 */
  isAPI76166Loading: boolean;
  /** 任务图展示: 接口请求返回数据 */
  dataAPI76166: API76166Res;
  /**  任务图展示: 接口数据请求方法 */
  fetchAPI76166Data: (inputs: API76166Req, config?: YWRequestConfig) => Promise<API76166Res>;
  /** 任务图展示: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76166 = ():IUseGetAPI76166Return => {
  let isMount = true;
  const [isAPI76166Loading, setIsAPI76166Loading] = useState(false);
  const [dataAPI76166, setDataAPI76166] = useState<API76166Res>({} as API76166Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/task/view`;

  const fetchAPI76166Data = async (inputs: API76166Req, config?: YWRequestConfig): Promise<API76166Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76166Req>) || {}) as API76166Req;
    
  
    if ( isMount ) {
      setIsAPI76166Loading(true);
    }

    try {
      
      const res: any = await Request.get<API76166Res>(`${basePath}/yoaichat-web/task/instance/task/view/${parseParams<API76166Req>(params)}`, {
        loginHost: loginPath,
        ...config
      });
      
      if (isMount) {
        setDataAPI76166(res || {} as API76166Res);
        setIsAPI76166Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76166Loading(false);
      }
      return false as unknown as API76166Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76166Loading,
    dataAPI76166,
    fetchAPI76166Data,
    requestUrl,
  }
}

